import { Injectable } from '@angular/core';
import {
  AnalyticsSiteAssets,
  ClickEventAnalytics
} from '../../../../models/utils';
import { FilterData } from '../../../../models/utils/analytics-extended.interfaces';
import { SearchAnalyticsData } from '../../../../types/analytics.interface';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsDataPopulateHelperService {
  getElementLabel(elementRef: HTMLElement): string {
    return elementRef.textContent?.trim()?.toLowerCase() || '';
  }

  getCheckboxLabel(elementRef: HTMLElement): string {
    return (
      elementRef.nextElementSibling?.textContent?.trim()?.toLowerCase() ||
      elementRef.previousElementSibling?.textContent?.trim()?.toLowerCase() ||
      ''
    );
  }

  getDataAttribute(elementRef: HTMLElement, attribute: string): string {
    return elementRef.closest(`[${attribute}]`)?.getAttribute(attribute) || '';
  }

  encryptEmail(email: string): string {
    return email ? btoa(email) : '';
  }

  getEmailDomain(email: string): string {
    return email ? email.split('@')[1] || '' : '';
  }

  getValidValue(value: string): string {
    return value ?? '';
  }

  getEventType(event?: Event): string {
    return event?.type === 'keypress' &&
      (event as KeyboardEvent).key === 'Enter'
      ? (event as KeyboardEvent).key
      : 'click';
  }

  getLinkName(elementRef: HTMLElement, useDataAttributes?: boolean): string {
    return useDataAttributes
      ? this.getDataAttribute(elementRef, 'data-acdl-name') ||
          elementRef.textContent?.trim() ||
          ''
      : this.getElementLabel(elementRef);
  }

  getLinkEventDetail(
    action: string,
    name: string,
    useDataAttributes?: boolean
  ): string {
    // If using data attributes and action already ends with 'click', don't append it again
    if (useDataAttributes) {
      return action.endsWith(' click') ? action : `${action} click`;
    }
    return `${action}${name} click`;
  }

  enrichAnalyticsData(
    analyticsData: ClickEventAnalytics,
    filters?: FilterData[],
    searchData?: SearchAnalyticsData
  ): ClickEventAnalytics {
    return {
      ...analyticsData,
      ...(filters && { filter: filters }),
      ...(searchData && searchData)
    };
  }

  buildComponentInfo(
    parent: Element,
    componentType: string,
    campaignId?: string | null
  ): AnalyticsSiteAssets {
    const allOfType = document.querySelectorAll(
      `[data-acdl-component-type="${componentType}"]`
    );
    const index = Array.from(allOfType).indexOf(parent);
    const result = {
      index: index + 1,
      count: allOfType.length
    };
    const site_assets: AnalyticsSiteAssets = {
      id: componentType + result.index,
      position: `${result.index} of ${result.count}`,
      campaign_id: campaignId || ''
    };
    return site_assets;
  }
}
